<template>
        <div class="flex items-center justify-center">
            <div class="completed w-full text-center">
                <img
                    data-testid="image"
                    src="@assets/images/pages/shield.png"
                    width="54"
                    height="54"
                    alt="success"
                    class="completed__image mx-auto object-contain"
                />
                <h1 data-testid="title" class="completed__title text-darkblue h2 font-semibold">
                    {{ title }}
                </h1>
                <div
                    data-testid="description"
                    class="completed__desc text-md font-normal"
                    v-html="description"
                ></div>

                <Button data-testid="action" v-if="showButtonCompleted" color="hyperlead" class="w-full" :to="to">{{buttonText}}</Button>
            </div>
        </div>
</template>

<script>
import Button from '../../components/Button/Button.vue';

export default {
    components: { Button },
    name: "completed",

    props: {
        title: String,
        description: String,
        buttonText: String,
        to: Object,
        showButtonCompleted: {
            type: Boolean,
            default: true,
        }
    }
};
</script>

<style lang="scss">
.completed {
    &__image {
        margin-bottom: 24px;
    }

    &__title {
        margin-bottom: 3px;
    }

    &__desc {
        margin-bottom: 96px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Box/Completed.vue